import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import OtherService from "../services/Other";
import toast from "react-hot-toast";
import Form from "react-bootstrap/Form";
import { Select } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

const SaleDataReport = () => {
  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const currentYear = new Date().getFullYear();

  const years = Array.from({ length: 10 }, (_, index) => {
    const year = currentYear - index;

    return {
      value: String(year),
      label: String(year),
    };
  });
  const userInfo = JSON.parse(localStorage.getItem("userData")).description;
  const navigate = useNavigate();
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [pointStatementDates, setPointStatementDates] = useState({
    month: "",
    year: "",
  });

  const saleInformationDownload = async () => {
    const { fromMonth, fromYear, toMonth, toYear } = pointStatementDates;
    if (!fromMonth || !fromYear || !toMonth || !toYear) {
      toast.error("Please select month and year fields");
      return;
    }

    try {
      setIsButtonLoading(true);
      const payload = {
        from_month: fromMonth,
        from_year: fromYear,
        to_month: toMonth,
        to_year: toYear,
      };

      const response = await OtherService.getSaleDataDownload(payload);
      const fileUrl = response?.response?.file_url;

      if (!fileUrl) {
        toast.error(response?.response?.message || "File URL not found");
        return;
      }
      window.open(fileUrl, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Failed to download point statement");
    } finally {
      setIsButtonLoading(false);
    }
  };

  return (
    <>
      <BreadCrumbSecttion
        pageTitle="Download Sale Information"
        currentPageName="Download Sale Information"
      />
      <section className="padTop50">
        <Container>
          <Row className="justify-content-center align-item-center h-100">
            <Col xs={12}>
              <div className="userInfoBox">
                <div className="dashboard-title">
                </div>
                <div className="dashboard-details">
                  <Row>
                    <Col xs={12} lg={3} className="mb-3">
                      <Form.Label>From Month</Form.Label>
                      <Select
                        placeholder="Select from month"
                        value={pointStatementDates.fromMonth || undefined}
                        options={months}
                        className="w-100"
                        size="large"
                        onChange={(value) =>
                          setPointStatementDates((prev) => ({
                            ...prev,
                            fromMonth: value,
                          }))
                        }
                      />
                    </Col>

                    <Col xs={12} lg={3} className="mb-3">
                      <Form.Label>From Year</Form.Label>
                      <Select
                        placeholder="Select from year"
                        value={pointStatementDates.fromYear || undefined}
                        options={years}
                        className="w-100"
                        size="large"
                        onChange={(value) =>
                          setPointStatementDates((prev) => ({
                            ...prev,
                            fromYear: value,
                          }))
                        }
                      />
                    </Col>

                    <Col xs={12} lg={3} className="mb-3">
                      <Form.Label>To Month</Form.Label>
                      <Select
                        placeholder="Select to month"
                        value={pointStatementDates.toMonth || undefined}
                        options={months}
                        className="w-100"
                        size="large"
                        onChange={(value) =>
                          setPointStatementDates((prev) => ({
                            ...prev,
                            toMonth: value,
                          }))
                        }
                      />
                    </Col>

                    <Col xs={12} lg={3} className="mb-3">
                      <Form.Label>To Year</Form.Label>
                      <Select
                        placeholder="Select to year"
                        value={pointStatementDates.toYear || undefined}
                        options={years}
                        className="w-100"
                        size="large"
                        onChange={(value) =>
                          setPointStatementDates((prev) => ({
                            ...prev,
                            toYear: value,
                          }))
                        }
                      />
                    </Col>

                    <Col xs={12} lg={3}>
                      <PrimaryGradientButton
                        buttonText={
                          isButtonLoading ? "Processing..." : "Download"
                        }
                        disabled={isButtonLoading}
                        className={userInfo == "Dealer" ? "mt-4" : "mt-2"}
                        onClick={saleInformationDownload}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SaleDataReport;
